import { useState } from "react";

import { Button } from "@/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/ui/dialog";

const COPYRIGHT_TEXT =
  "Copyright \u00A9 2026 Battlefin Group, Inc. Copyright \u00A9 2026 S&P Global Market Intelligence.";

export const AdcAppFooter = () => {
  const [open, setOpen] = useState(false);

  return (
    <footer className="flex items-center justify-center py-2">
      <Button
        variant="link"
        className="text-muted-foreground text-xs h-auto p-0 hover:text-foreground"
        onClick={() => setOpen(true)}
      >
        {COPYRIGHT_TEXT}
      </Button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-lg">
          <DialogHeader>
            <DialogTitle>Copyright Notice</DialogTitle>
          </DialogHeader>
          <div className="flex flex-col gap-4 text-xs/relaxed text-muted-foreground">
            <section>
              <p className="font-medium text-foreground mb-1">
                Battlefin Group, Inc.
              </p>
              <p>
                Copyright &copy; 2026 Battlefin Group, Inc. All rights reserved.
                The Alt Data Consensus platform and all content, data, and
                materials contained therein are the proprietary property of
                Battlefin Group, Inc. and may not be reproduced, distributed, or
                transmitted in any form without the prior written permission of
                Battlefin Group, Inc.
              </p>
            </section>
            <section>
              <p className="font-medium text-foreground mb-1">
                S&amp;P Global Market Intelligence
              </p>
              <p>
                Copyright &copy; 2026 S&amp;P Global Market Intelligence, a
                division of S&amp;P Global Inc. All rights reserved.
              </p>
              <p className="mt-2">
                The information contained herein is obtained from sources
                believed to be reliable. S&amp;P Global Market Intelligence does
                not guarantee the accuracy, completeness, timeliness, or
                availability of the content, and is not responsible for any
                errors or omissions, regardless of the cause, or for the results
                obtained from the use of the content.
              </p>
              <p className="mt-2">
                S&amp;P GLOBAL MARKET INTELLIGENCE GIVES NO EXPRESS OR IMPLIED
                WARRANTIES, INCLUDING, BUT NOT LIMITED TO, ANY WARRANTIES OF
                MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE OR USE. In
                no event shall S&amp;P Global Market Intelligence be liable to
                any party for any direct, indirect, incidental, exemplary,
                compensatory, punitive, special, or consequential damages,
                costs, expenses, legal fees, or losses (including, without
                limitation, lost income or lost profits and opportunity costs)
                in connection with any use of the content even if advised of the
                possibility of such damages.
              </p>
            </section>
          </div>
        </DialogContent>
      </Dialog>
    </footer>
  );
};
